
import '@mdi/font/css/materialdesignicons.css'
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import vuetify from '@/plugins/vuetify'
import store from './store'
import VueToasted from 'vue-toasted'

import VueSocketIO from 'vue-socket.io'
import {baseURL} from './http-const'



Vue.config.productionTip = false

//axios.defaults.baseURL = (env === 'development') ? 'https://localhost:3000' : 'https://trust-x.ifxurl.io';


Vue.use(new VueSocketIO({ 
                debug:      true, 
                connection: baseURL, 
                vuex:       { store, actionPrefix: 'SOCKET_' }, 
                options:    { path: "/api/socket.io" }, 
                autoconnect: false,
}))


Vue.use(vuetify, {
  iconfont: 'mdi'
})


Vue.use(VueToasted, {
  iconPack : 'mdi' // set your iconPack, defaults to material. material|fontawesome|custom-class
});

//// register global toasts
//Vue.toasted.register('loginError', (payload) => {
//    if (!payload.message) {
//      return "Login error with undefinded message..."
//    }
//    return payload.message;
//},
//{
//    type: 'error'
//});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
